<template>
  <!-- <list msg="Welcome" /> -->
  <div id="app">
    <router-view> </router-view>
    <!-- <loading></loading> -->
  </div>
</template>

<script>
// import HelloWorld from "./components/HelloWorld.vue";
// import list from "@/components/list.vue";
// import loading from "./view/LoadingView.vue";

export default {
  name: "App",
  // components: { loading },
};
</script>

<style>
#app {
  /* color: #2c3e50; */
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; 
  /* margin-top: 60px; */
}
</style>
